var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
export var StyledDisputesContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > div {\n    margin: 0;\n    margin-bottom: ", "px;\n  }\n"], ["\n  > div {\n    margin: 0;\n    margin-bottom: ", "px;\n  }\n"])), spacing.large);
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map